module.exports = __webpack_public_path__ + "img/Modernisme_Tanker_i_tida2.bff35d6b.jpg";